<div class="ioh-not-authorized-container" [@fadeInOut]>
  <div class="ioh-not-authorized-content">
    <div class="p-grid p-dir-col">
      <div class="p-col mb-3">
        <span class="ioh-csx-common_stop"></span>
      </div>
      <div class="p-col">
        <h4 class="ioh-not-authorized-title">Access Denied</h4>
      </div>
      <div class="p-col mb-6">
        <p class="ioh-not-authorized-text">
          Looks like you are not authorized to view this page
        </p>
        <p class="ioh-not-authorized-text mail-text">
          Please send a email to this
          <a [href]="'mailto:DLTechIOH@csx.com'">DL Tech - IOH</a> for IOH
          access
        </p>
      </div>
    </div>
  </div>
</div>
